var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VContainer",style:({
        color: 'red',
        left: `${_vm.position.left}px`,
        top: `${_vm.position.top}px`,
      })})
}
var staticRenderFns = []

export { render, staticRenderFns }